import './groupBox.scss';
import React from 'react';
import classNames from 'classnames';
import ExtraInfoTitle from '../extraInfoTitle/ExtraInfoTitle';
/**
 * @desc 分组区域（无状态组件）
 * @author caoyx
 * @param 必传：
 *          title { String } 标题
 *        可选：
 *          explain { String } 说明
 *          riskScore { String } 风险评分
 *          fraudScore { String } 造假评分
 *          explain { String } 说明
 *          industry { String } 公司分类
 *
 * @example <GroupBox
 *           title="公司基本信息"
 *           explain='该公司在经营能力和经营能力和经营能力和经营能力和经营能力方面存在显著风险'
 *           industry='制造行业、小型低固定资产占比类公司'
 *       >
 *           456456454
 *       </GroupBox>
 */

export default function GroupBox({ title, className = '', explain, riskScore, fraudScore, industry, children, ...other }) {

    return (
        <div {...other} className={classNames('group-box', className)}>
            <div className="group-title">
                <span className="title">{title}</span>
                <ExtraInfoTitle explain={explain} riskScore={riskScore} fraudScore={fraudScore} industry={industry}/>
            </div>
            <div>{children}</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/groupBox/GroupBox.jsx